// extracted by mini-css-extract-plugin
export default {"cardContainer":"Table_cardContainer__6HXch","addButtonContainer":"Table_addButtonContainer__jVpFs","addNew":"Table_addNew__c+0p8","contentContainer":"Table_contentContainer__-s4iy"};